export default "__VITE_ASSET__DIidR1zT__"